'use client';

import { EdTechProductList } from '@ninjacart/nc-nk-edtech';

export function EdTechProductListTabLayout() {
  return (
    <>
        <EdTechProductList />
    </>
  );
}
